import type { ParameterNode } from '@data';

import { parameterFilterGroups } from './parameterFilters';

import type { FilterSelectionKey } from './parameterFilters';

const matchesFilterKey = (filterTags: readonly string[], filterKey: string) => filterTags.includes(filterKey);

const matchesGroupFilter = (filterTags: readonly string[], filterKey: FilterSelectionKey) => {
    const group = Object.entries(parameterFilterGroups).find(([groupKey]) => groupKey === filterKey)?.[1];
    if (group) {
        return group.children.some((childKey) => matchesFilterKey(filterTags, childKey));
    }

    return matchesFilterKey(filterTags, filterKey);
};

/**
 * Checks whether a parameter matches the selected filter-tag filters.
 *
 * @param filterTags Parameter filter tags.
 * @param filters Active parameter filters.
 * @param positions Active P-position filters.
 * @returns Whether the parameter is included by the active filters.
 */
const matchesParameter = (
    filterTags: readonly string[],
    filters: readonly FilterSelectionKey[],
    positions: readonly string[],
) => {
    const matchesPosition = positions.length === 0 || positions.some((position) => filterTags.includes(position));
    const matchesFilter =
        filters.length === 0 || filters.some((filterKey) => matchesGroupFilter(filterTags, filterKey));

    return matchesPosition && matchesFilter;
};

export const filterParameters = (
    parameters: readonly ParameterNode[],
    filters: readonly FilterSelectionKey[],
    positions: readonly string[],
) => parameters.filter(({ parameter }) => matchesParameter(parameter.filterTags ?? [], filters, positions));
